import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SalesforceV2ReaderForm from '../forms/salesforce-v2-reader-form';
import { salesforceV2ReaderValidationSchema } from '../schema/salesforceV2Reader';

export default function SalesforceV2ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Salesforce V2 Reader Node Details',
        altText: 'Salesforce V2 Reader Node',
        defaultLabel: 'Salesforce V2 Reader Node',
      }}
    >
      <CommonNode
        FormComponent={SalesforceV2ReaderForm}
        schemaResolver={salesforceV2ReaderValidationSchema}
      />
    </NodeProvider>
  );
}
